import '../styles/Description.css';
import imgBg from '../images/5.jpg';

const DESCRIPTION_TEXT = `En TMSTUDIO contamos con más de 10 años de experiencia. En la actualidad somos una empresa líder y premium en el formato de plataformas públicas y contamos con un gran conocimiento en el manejo de páginas de privados. El equipo TM ha creado perfiles de muy alto nivel y muy buenos resultados en todo el país y continúa formando nuevos y mejores talentos destacados por su manera profesional, disciplinada y motivadora de trabajar, en donde el objetivo principal es generar resultados en el menor tiempo posible y así poder cambiar y mejorar tu estilo de vida. Sé parte de TMSTUDIO.`;

function Description() {
  return (
    <section id="quienes-somos" className="tm-section tm-description-section">
      <div className="tm-description-bg" style={{ backgroundImage: `url(${imgBg})` }} />
      <div className="tm-description-overlay" />
      <div className="tm-container tm-description-container">
        <div className="tm-description-box">
          <h2 className="tm-description-title">QUIÉNES SOMOS</h2>
          <p className="tm-description-text">{DESCRIPTION_TEXT}</p>
          <a href="#beneficios" className="tm-description-cta btn-hover">
            Conoce más
            <span className="material-symbols-outlined tm-description-cta-icon">arrow_forward</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Description;
